import React, { Component } from "react";
import { Grid, Row, Col, Button } from "react-bootstrap";
import { fetchIncomeTaxRequest } from "../../../api/incomeTax";
import { formatCurrency } from "../../../helpers/functions/currency.js";
import moment from "moment";

class IncomeTaxDetails extends Component {

    constructor(props) {
        super(props);
        this.state = {
            resource: {
                _id: null,
                annualSalaryFrom: null,
                annualSalaryTo: null,
                taxFixedAmount: null,
                taxRate: null,
                exemptAmount: null,
                effectiveDate: null,
                createdAt: null,
                updatedAt: null
            }
        }
    }

    componentDidMount() {
        const { instanceId } = this.props;
        if(instanceId) {
            this.fetchIncomeTax(instanceId)
        }
    }

    fetchIncomeTax = (id) => {
        fetchIncomeTaxRequest(id, result => this.setState({resource: result}), error => console.log(error))
    }

    render() {

        const { 
            _id, 
            annualSalaryFrom,
            annualSalaryTo,
            taxFixedAmount,
            taxRate,
            exemptAmount,
            effectiveDate,
            createdAt, 
            updatedAt
          } = this.state.resource;

        return (
            <Grid fluid>
                <div className="form-header">
                    <h3 className="text-secondary font-weight-bold">
                        Income Tax Instance Details
                    </h3>
                    <Button className="btn btn-primary top-btn" onClick={() => this.props.goBack()}>Back to list</Button>
                </div>
                <Row>
                    <Col md={12}>
                        <div className="typo-line">
                            <div>
                            <p className="category">Instance ID</p>
                            {_id || 'N/A'}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Annual Salary From</p>
                            {formatCurrency(annualSalaryFrom) || 'N/A'}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Annual Salary To</p>
                            {formatCurrency(annualSalaryTo) || 'N/A'}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Tax Fixed Amount</p>
                            {formatCurrency(taxFixedAmount) || 'N/A'}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Tax Rate</p>
                            {taxRate || 'N/A'}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Exempt Amount</p>
                            {formatCurrency(exemptAmount) || 'N/A'}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Effective Date</p>
                            {effectiveDate ? moment(effectiveDate).format('MM/DD/YYYY') : 'N/A'}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Created At</p>
                            {createdAt ? moment(createdAt).format('MMMM Do YYYY, h:mm:ss a') : 'N/A'}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Updated At</p>
                            {updatedAt ? moment(updatedAt).format('MMMM Do YYYY, h:mm:ss a') : 'N/A'}
                            </div>
                        </div>
                        <Button className="btn btn-primary bottom-btn" onClick={() => this.props.goToEditForm('income-tax', _id)}>Edit</Button>
                    </Col>
                </Row>
            </Grid>
        );
    }
}

export default IncomeTaxDetails;
